/* eslint-disable */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
// import core & vendor packages below
import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Row, Col, FormControl, Button, Modal } from 'react-bootstrap';

// import components
import {
  completeItem,
  getEquipments,
  selectborrowReturn,
  getSingleBorrowedData,
} from 'reducers/borrowReturnReducer';
import FormUI from 'components/UI/FormUI';

// Import assets below
import './modal.scss';
import { ReactComponent as CircleXMark } from 'assets/svg/circle-xmark.svg';

// main component
const CompleteReturnModal = ({ showModal, fetchData, setShowModal }) => {
  const dispatch = useDispatch();

  // New Borrow Return
  const borrowReturnState = useSelector(selectborrowReturn);
  const { singleData, completeLogs, singleDataIncluded } = borrowReturnState;

  // States
  const [search, setSearch] = useState({
    code: '',
    itemGroup: '',
  });

  const [formData, setFormData] = useState({
    borrowedBy: '',
    remarks: '',
  });

  const [finalItem, setFinalItem] = useState([]);

  // Api call
  const getInventoryItems = (clear = false) => {
    let params;

    if (clear) {
      setSearch({
        code: '',
        itemGroup: '',
      });
    }

    params = {
      per_page: 5,
      is_medicine: 0,
      q: search?.code,
      include: ['group'],
    };

    if (search?.itemGroup && clear === false) {
      params.group_id = search?.itemGroup;
    }

    if (clear) {
      params.q = '';
    }

    dispatch(getEquipments(params));
  };

  // Handle POST api
  const handleSubmit = () => {
    const payload = {
      id: singleData?.id,
      payload: {
        remarks: formData?.remarks,
      },
    };

    dispatch(completeItem(payload));

    const { isLoading, isFailed, isSuccess, error } = completeLogs;
    
    if (isFailed) {
      toast.error(`${error[0]?.detail} (${error[0]?.code})`);
      console.log(error);
      return;
    }

    closeModal();
    setFormData({});
    fetchData();
    setFinalItem([]);
    toast.success('Successfully completed.');
  };

  const closeModal = () => {
    setShowModal((prev) => {
      return {
        ...prev,
        data: null,
        completeReturn: false,
      };
    });

    setFinalItem([]);
    setFormData({
      borrowedBy: '',
      remarks: '',
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    getInventoryItems();
  }, []);

  // Get Submit Data result
  useEffect(() => {
    /* const { isLoading, isFailed, isSuccess, error } = completeLogs;
    console.log('is loading? (useEffect) ', isLoading);

    if (isFailed) {
      toast.error(`${error[0]?.detail} (${error[0]?.code})`);
      console.log(error);
    }

    if (isSuccess) {
      closeModal();
      setFormData({});
      fetchData();
      setFinalItem([]);
      toast.success('Successfully completed.');
    } */
  }, [completeLogs]);

  // Modal Data
  useEffect(() => {
    if (showModal?.data && showModal?.completeReturn === true) {
      dispatch(getSingleBorrowedData(showModal?.data?.id));
    }
  }, [showModal]);

  // Get data from API
  useEffect(() => {
    if (singleData && finalItem.length === 0) {
      const itemID = singleData?.relationships?.item?.data[0]?.id;

      const itemData = singleDataIncluded.find((dd) => {
        return parseInt(dd?.id) === parseInt(itemID) && dd?.type === 'items';
      });

      if (itemID && itemData) {
        const newFinalData = {
          id: itemID,
          data: itemData,
        };

        setFormData({
          borrowedBy: singleData?.attributes?.borrowed_by,
          remarks: singleData?.attributes?.remarks,
        });
        setFinalItem([newFinalData]);
      }
    }
  }, [singleData]);

  return (
    <Modal
      size='lg'
      show={showModal?.completeReturn}
      onHide={() => {
        closeModal();
      }}
      aria-labelledby='Request Item Modal'
      className='view-borrowed-item request-item'
    >
      <Modal.Body>
        <div className='view-borrowed-item-header'>
          <div className='d-flex header'>
            <p>COMPLETE RETURN?</p>

            <CircleXMark style={{ width: '2em', cursor: 'pointer' }} onClick={() => closeModal()} />
          </div>
        </div>

        <FormUI>
          <Form className='item-information-form'>
            <Row className='mb-2'>
              <Col>
                <Form.Group className='mb-3 form-group'>
                  <Form.Label>Remarks</Form.Label>
                  <FormControl
                    type='text'
                    as='textarea'
                    name='remarks'
                    onChange={handleChange}
                    value={formData?.remarks}
                    placeholder='Remarks Here'
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='buttons-cont'>
                  <Button
                    onClick={() => {
                      handleSubmit();
                    }}
                    variant='primary'
                    className='add-button'
                  >
                    Complete
                  </Button>
                  <Button
                    onClick={() => {
                      closeModal();
                    }}
                    className='clear-button'
                    variant='secondary'
                  >
                    Close
                  </Button>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </FormUI>
      </Modal.Body>
    </Modal>
  );
};

export default CompleteReturnModal;
